const htmlClassList = document.documentElement.classList;
let timeout = -1;

window.addEventListener('resize', () => {
  if (!htmlClassList.contains('no-transition')) {
    htmlClassList.add('no-transition');
  }

  if (timeout !== -1) {
    clearTimeout(timeout);
  }

  timeout = setTimeout(() => {
    timeout = -1;
    if (htmlClassList.contains('no-transition')) {
      htmlClassList.remove('no-transition');
    }
  }, 0);
});
